import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';

import { setCurrency } from 'actions';
import { CURRENCIES } from '../../constants';


class CurrencySwitcher extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      active: 'EUR',
      isSmallScreen: false
    };
  }

  componentDidMount() {
    this.setState({

      // I've removed inBrowser check at all
      // This method should not fire on server, right?
      isSmallScreen: window.innerWidth < 480
    });
  }

  select(active) {
    this.setState({ active });
    this.props.setCurrency(active);
  }

  render() {
    const { active } = this.state;

    return (
      <Dropdown pullRight={this.state.isSmallScreen} id="CurrencySwitcher" className="currencie-select">
        <Dropdown.Toggle noCaret>
          {CURRENCIES.find(el => el.value === active).title}
          <span className="dropdown-toggle-icon">
            <span className="caret" />
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu >
          {CURRENCIES.map(el =>
            <MenuItem
              key={el.value}
              eventKey={el.value}
              active={active === el.value}
              onClick={this.select.bind(this, el.value)}
            >
              {el.title}
            </MenuItem>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default connect(null, { setCurrency })(CurrencySwitcher);



// WEBPACK FOOTER //
// ./src/components/Header/CurrencySwitcher.js